import * as React from 'react';
import './QuickSearch.css';
interface IList {
    id: string,
    value: string
}
interface IParams {
    isLoading: boolean,
    data: IList[];
    callAPI: (e: string) => void;
}
interface IState {
    hasData: boolean,
    refInput: any
}

class QuickSearch extends React.Component<IParams, IState>{
    constructor(props: any) {
        super(props);
        this.state = {
            hasData: false,
            refInput: React.createRef<any>()
        }
    }
    public changeInput = (e:any) => {
        e.preventDefault();
        if(e && e.currentTarget.value && e.currentTarget.value.length > 0){
            this.setState({ hasData: true})
        }else{
            this.setState({ hasData: false})
        }
        if(e && e.currentTarget.value && e.currentTarget.value.length >= 4 && e.keyCode === 13) {
            this.props.callAPI(e.currentTarget.value)
        }
    }
    public resetInput = () => {
        this.props.callAPI('');
        if(this.state.refInput && this.state.refInput.current){
            this.state.refInput.current.value = ''
        }
        this.setState({ hasData: false})
    }
    public render() {
        const classN = this.props.data && this.props.data.length>0 ? 'quick-list' : 'quick-list hidden'
        return (
            <React.Fragment>
                <div className="container-search">
                    <div className="form-group">
                        <i className="fas fa-search" />
                        <input
                            ref={this.state.refInput}
                            className="form-control"
                            placeholder="Find ETS by CBL Number"
                            type="text"
                            onKeyUp={this.changeInput}
                        />
                        {this.state.hasData && <i className="fas fa-times" onClick={this.resetInput} />}
                    </div>
                    <ul className={classN}>
                        {this.props.data && this.props.data.length > 0 ? 
                            this.props.data.map((val:IList) => <li key={val.id}><a href={`/job-costing/ets/${val.id}`}>{val.value}</a></li>)
                        : ''}
                    </ul>
                </div>
            </React.Fragment>
        );
    }
}
export default QuickSearch;
